import Refresh from "@mui/icons-material/Refresh";
import { IconButton } from "@mui/material";

export interface RefreshButtonProps {
  invalidateQueries: Function
}

export const RefreshButton = (props: RefreshButtonProps) => {
  return (
    <IconButton
      style={{ cursor: "pointer" }}
      onClick={() => props.invalidateQueries()}>
      <Refresh />
    </IconButton>);
}